import { ReactNode } from 'react'
import { Currency } from '@pancakeswap/sdk'
import { ArrowForwardIcon, ArrowUpIcon, AutoColumn, Box, Flex, Spinner, Text } from '@pancakeswap/uikit'
import { CurrencyLogo } from '@pancakeswap/widgets-internal'
import { Typography } from '@/components/ui/typography'
import { CircleArrowUpIcon, CircleFadingArrowUp } from 'lucide-react'

interface SwapPendingModalContentProps {
  title: string
  showIcon?: boolean
  currencyA?: Currency
  currencyB?: Currency
  amountA: string
  amountB: string
  children?: ReactNode
}

export const SwapPendingModalContent: React.FC<SwapPendingModalContentProps> = ({
  title,
  showIcon,
  currencyA,
  currencyB,
  amountA,
  amountB,
  children,
}) => {
  const symbolA = currencyA?.symbol
  const symbolB = currencyB?.symbol

  return (
    <div>
      {showIcon ? (
        <Box margin="auto auto 36px auto" width="fit-content">
          <CircleArrowUpIcon className={'text-success size-24'} />
        </Box>
      ) : (
        <div className={'py-8 flex justify-center'}>
          <Spinner className={'size-24'} />
        </div>
      )}
      <AutoColumn gap="12px" justify="center">
        <Typography>{title}</Typography>
        <Flex>
          <Flex>
            <Text mr="4px" fontSize="14px">{`${amountA} ${symbolA}`}</Text>
            <CurrencyLogo size="20px" currency={currencyA} />
          </Flex>
          <Box m="0 8px">
            <ArrowForwardIcon color="textSubtle" />
          </Box>
          <Flex>
            <Text mr="4px" fontSize="14px">{`${amountB} ${symbolB}`}</Text>
            <CurrencyLogo size="20px" currency={currencyB} />
          </Flex>
        </Flex>
        {children}
      </AutoColumn>
    </div>
  )
}
